import PropTypes from 'prop-types';
import KitoCard from '../../../../components/DataDisplay/Card';
import ProgressBar from '../../../../components/ProgressBar/ProgressBar';

function AidCard({ title, description, percent, imageSrc, onClick, backgroundColor, progressLabel }) {
  return (
    <KitoCard
      key={title}
      title={title}
      subtitle={description}
      image={imageSrc}
      color={backgroundColor}
      onClick={onClick}
      fullWidth
    >
      <ProgressBar width={100} percent={percent} color={backgroundColor} status={progressLabel || ''} showData />
    </KitoCard>
  );
}

export default AidCard;

AidCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  imageSrc: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
